import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';

import { ApiUrlHttpInterceptor } from './core/interceptors';

export const appInterceptor: (Provider | EnvironmentProviders)[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiUrlHttpInterceptor,
    multi: true,
  },
];
